<template>
  <form @submit.prevent="handleSubmit">
    <template v-for="(component, x) in builder">
      <div  class="input-box xs" v-bind:key="x" v-if="(component.type === 'title') && isValid(component)">
        <h4>{{component.title}}</h4>
      </div>
		<div class="input-box xs" v-bind:key="x" v-if="(component.type === 'label') && isValid(component)">
			<label class="no-float">{{component.title}}</label>
		</div>
		<div class="input-box" :class="getLabelSize(component.title.length)" v-bind:key="x"
			v-if="component.type === 'text' && isValid(component)">
			<label class="" :class="{'has-error': errors && errors[component.id]}">{{component.title}}</label>
			<input
			:required="component.required"
			class="w-full form-control form-input form-input-bordered"
			type="text"
			@input="force()"
			v-model="value[component.id]"
			/>
      <!-- <span class="info-icon">
          <template>
              <a-tooltip style="margin:0 5px;">
                  <template slot="title">
                      Para aferir sua circunferência abdominal é necessária uma fita métrica.
                      Posicione a fita na altura do umbigo e envolva toda sua cintura. Insira o valor no campo abaixo em centímetros.
                  </template>
                  <font-awesome-icon :icon="['fa', 'question-circle']"/>
              </a-tooltip>
          </template>
      </span> -->
			<small class="error" v-if="errors && errors[component.id]">{{errors[component.id]}}</small>
      </div>
		<div class="input-box" :class="getLabelSize(component.title.length)" v-bind:key="x"
			v-if="component.type === 'float' && isValid(component)">
			<label class="" :class="{'has-error': errors && errors[component.id]}">{{component.title}}</label>
			<input
			:required="component.required"
			class="w-full form-control form-input form-input-bordered"
			type="text"
      v-on:keypress="onlyNumbers"
      pattern="[0-9]*"
			@input="force()"
			v-model="value[component.id]"
			/>
			<small class="error" v-if="errors && errors[component.id]">{{errors[component.id]}}</small>
      </div>
      <div class="input-box" :class="getLabelSize(component.title.length)" v-bind:key="x"
           v-if="(component.type === 'date' ) && isValid(component)">
        <label class="" :class="{'has-error': errors && errors[component.id]}">{{component.title}}</label>
        <input
          :required="component.required"
          class="w-full form-control form-input form-input-bordered"
          type="text"
          @input="force()"
          placeholder="Ex: 01/01/2021"
          v-mask="'##/##/####'"
          v-model="value[component.id]"
        />
        <small class="error" v-if="errors && errors[component.id]">{{errors[component.id]}}</small>
      </div>
      <div class="input-box" :class="getLabelSize(component.title.length)" v-bind:key="x"
           v-if="(component.type === 'datetime' ) && isValid(component)">
			<h5 class="" :class="{'has-error': errors && errors[component.id]}">{{component.title}}</h5>
			<div class="input-box sm">
			<label>Data</label>
			<input
				:required="component.required"
				class="w-full form-control form-input form-input-bordered"
				type="text"
				@input="force()"
        v-on:keypress="onlyNumbers"
				placeholder="Ex: 01/01/2021"
				v-mask="'##/##/####'"
				v-model="value[component.id].date"
			/>
			<small class="error" v-if="errors && errors['date']">{{errors['date']}}</small>
        </div>
        <div class="input-box sm">
			<label class="">Hora</label>
			<input
				:required="component.required"
				class="w-full form-control form-input form-input-bordered"
				type="text"
				@input="force()"
				placeholder="Ex: 12:00"
				v-mask="'##:##'"
				v-model="value[component.id].time"
			/>
			<small class="error" v-if="errors && errors['time']">{{errors['time']}}</small>
        </div>
      </div>
      <div class="input-wrapper" v-bind:key="x" v-if="(component.type === 'imc') && isValid(component)">
        <div class="input-box sm">
          <label class="" :class="{'has-error': errors && errors['height'] }">Altura (metros)</label>
          <input
            :required="component.required"
            class="w-full form-control form-input form-input-bordered"
            type="text"
            placeholder="Ex: 1,75"
            v-mask="'#,##'"
            @input="force()"
            v-model="value[component.id].heigth"
          />
          <small class="error" v-if="errors && errors['height']">{{errors['height']}}</small>
        </div>
        <div class="input-box sm">
          <label class="" :class="{'has-error': errors && errors['weight']}">Peso (quilos)</label>
          <input
            :required="component.required"
            class="w-full form-control form-input form-input-bordered"
            type="text"
            placeholder="Ex: 75"
            v-on:keypress="onlyNumbers"
            pattern="[0-9]*"
            @input="force()"
            v-model="value[component.id].weigth"
          />
          <small class="error" v-if="errors && errors['weight']">{{errors['weight']}}</small>
        </div>

      </div>
      <!-- <div :errors="errors" :field="field"
                     v-else-if="component.type === 'cpf' && isValid(component)">
          {{component.name}}
          <template slot="field">

              <input
                  :disabled="!!confirmed_at"
                  :required="component.required"
                  class="w-full form-control form-input form-input-bordered"
                  type="text"
                  v-model="answers[component.id]"
              />
          </template>
      </div> -->
      <div class="input-box" :class="getLabelSize(component.title.length)" v-bind:key="x"
           v-if="component.type === 'select' && isValid(component, 'select')">
        <label class="" :class="{'has-error': errors && errors[component.id]}">{{component.title}}</label>
        <select
            class="block w-full form-control-sm form-select"
            label="name"
            v-model="value[component.id]"
            @change="emit()"
        >
          <option selected value="">Selecione uma opção</option>
          <option :value="item.id" v-for="item in component.options" v-if="isValid(item, 'select')"
                  v-bind:key="item.id">{{item.label}}
          </option>
        </select>
        <small class="error" v-if="errors && errors[component.id]">{{errors[component.id]}}</small>
      </div>
      <div class="input-box" :class="getLabelSize(component.title.length)" v-bind:key="x"
           v-if="component.type === 'multiselect'">
        <label class="" :class="{'has-error': errors && errors[component.id]}">{{component.title}}</label>
        <multiselect :allow-empty="true"
                     :multiple="true"
                     :options="component.options"
                     :searchable="false"
                     deselect-label="Remover seleção"
                     label="label"
                     placeholder="Selecione uma ou mais opções"
                     select-label="Selecionar"
                     selectedLabel="Selecionado"
                     track-by="value"
                     	@change="emitMultiselect(component.id)"
                    	@input="emitMultiselect(component.id)"
                     v-model="answers[component.id]"></multiselect>
        <small class="error" v-if="errors && errors[component.id]">{{errors[component.id]}}</small>
      </div>

      <!--
            *
            *  Componente de DATA
            *
     -->
      <!-- <div :errors="errors" :field="field"
                     v-else-if="component.type === 'date' && isValid(component)">
          {{component.name}}
          <template slot="field" style="    padding: 15px 2rem;">
              <input :disabled="!!confirmed_at"
                     type="date"
                     v-model="answers[component.id]"/>
          </template>
      </div> -->
      <!--
                        *
                        *  Componente de DATA e HORA
                        *
                 -->
      <!-- <div :errors="errors" :field="field"
                     v-else-if="component.type === 'date' && isValid(component)">
          {{component.name}}
          <template slot="field" style="    padding: 15px 2rem;">
              <input :disabled="!!confirmed_at"
                     type="datetime-local"
                     v-model="answers[component.id]"/>
          </template>
      </div> -->
      <!--
        *
        *  Componente de AVATAR
        *
      -->
      <!-- <div :errors="errors" :field="field"
                     v-else-if="component.type === 'avatar' && isValid(component)">
          {{component.name}}
          <template slot="field">
              <avatar
                  :disabled="!!confirmed_at"
                  :required="component.required"
                  v-model="answers[component.id]"
              ></avatar>
          </template>
      </div> -->
      <!--
       *
       *  Componente de AVATAR
       *
     -->
      <!-- <div :errors="errors" :field="field"
                     v-else-if="component.type === 'cid10' && isValid(component)">
          {{component.name}}
          <template slot="field">

              <cid10
                  :disabled="!!confirmed_at"
                  :required="component.required"
                  v-model="answers[component.id]"
              ></cid10>
          </template>
      </div> -->
    </template>
  </form>
</template>

<script>
  import {GET_FORM} from "../../services/form"
  
  import Multiselect from 'vue-multiselect';
  import "../../assets/vue-multiselect.min.css";
  import Cid10 from "./Fields/Cid10";

  import DisplayRulesFunctions from './DisplayRulesFunctions';

  export default {
  
    components: {Multiselect, Cid10},
    props: ['value', 'builder', 'formAnswers', 'errors'],
    data() {
      return {
        evaluation: null,
        answers: {},
        confirmed_at: null,
        options: [],
        titles: [],
      };
    },
    mounted() {

    },
    watch: {
      value: function (newValue) {
        this.$emit('value', newValue);
      }
    },
    methods: {
      force() {
        this.$parent.$children.map(child => {
          child.$forceUpdate();
        })
      },
      async loadForm() {
        const data = await GET_FORM(this.kit_type);
        this.builder = data;
      },
      emit() {
        this.$emit('value', this.value);
        this.force();
      },
		emitMultiselect(idComponent) {
			let answers = [];
			this.answers[idComponent].forEach(answer => {
				answers.push(answer.id);
			});
			this.value[idComponent] = answers;
			this.$emit('value', this.value);
		},
      isValid(component, opt = '') {
        let ret = true;
        try {
          component.display_rules.forEach(rule => {
            if (rule.value_of_type && !DisplayRulesFunctions[rule.value_of_type](rule, this.formAnswers, this.$store.state.user)) {
              ret = false;
              return false;
            }
          });
        } catch (e) {
          console.log("tivemos um erro ", component, e);
        }
        return ret;
      },
      getMuliselect(items, answers) {
        let res = '';
        if (answers)
          answers.forEach(answer => {
            items.forEach(item => {
              if (answer == item.id)
                res = res + item.name + ', ';
            });
          });
        return res.slice(0, -2);
      },
      getMultiSize(items, answers) {
        let ret = 14;
        if (!!answers)
          answers.forEach(answer => {
            items.forEach(item => {
              if (answer == item.id)
                ret += 14;
            });
          });
        return 'height: ' + ret + 'px';
      },
      onlyNumbers(evt) {
        evt = (evt) ? evt : window.event;
        let charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      getLabelSize(length) {
        if (length < 49) {
          return 'sm';
        } else if (length >= 49 && length < 99) {
          return 'md';
        } else if (length >= 99 && length < 149) {
          return 'lg';
        } else if (length >= 149) {
          return 'xl';
        }
      }
    }
  }
</script>

<style src="@/assets/vue-multiselect.min.css">

</style>



// WEBPACK FOOTER //
// src/components/FormBuilder/FormBuilder.vue